import {
  Field,
  FieldAnswer,
  FolderItem,
  Patient,
  PatientItemStatus,
  Reference
} from "@/src/data/allTypes";
import { USER } from "@/src/data/globalVariables";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId, isMobile, isNurse } from "@/src/utils/utils";
import { EventInput } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import FullCalendar from "@fullcalendar/react";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import {
  ResourceInput
} from "@fullcalendar/resource/index.js";
import timeGridPlugin from "@fullcalendar/timegrid";
import moment from "moment";
import { openAnswerTimelineActions } from "./AnswerTimelineActions";
import { AnswersTimelineEvent } from "./answersTimelineEvent";
import { openAnswersTimelineForm } from "./answersTimelineForm";
import { AnswersTimelineResource } from "./answersTimelineResource";

export function AnswersTimeline({
  answers,
  references,
  patient,
  parent,
  start,
  end,
  initialStatus = "finished",
  onChange,
}: {
  answers: FieldAnswer[];
  references: Reference[];
  patient: Patient;
  parent: FolderItem;
  start: string;
  end: string;
  initialStatus?: PatientItemStatus;
  onChange: () => void;
}) {
  function getFieldIds(reference: Reference) {
    let ids: string[] = [];
    for (let section of reference.sections || []) {
      for (let field of section?.fields || []) {
        ids.push(getItemId(field));
      }
    }
    return ids;
  }

  function getResources() {
    const resources: ResourceInput[] = [];
    for (let reference of references) {
      const fieldIds = getFieldIds(reference);
      let children: ResourceInput[] = [];
      for (let section of reference.sections || []) {
        for (let field of section?.fields || []) {
          if (!field) continue;
          if (!field.name && !field.type) continue;
          children.push({
            id: getItemId(field),
            title: field.name || reference.name || "",
            // children: answers
            //   ?.filter((answer) => {
            //     if (!answer) return false;
            //     if (!fieldIds.includes(getItemId(answer.field))) return false;
            //     if (!answer.start) return false;
            //     if (!answer.end) return false;
            //     if (answer.start < start || answer.start > end) return false;
            //     if (answer.end < start || answer.end > end) return false;
            //     return true;
            //   })
            //   .map((answer) => {
            //     return {
            //       id: answer.id || "",
            //       title: answer.value || "Sans nom",
            //       start: moment(answer.start).format("YYYY-MM-DD HH:mm:ss"),
            //       end: moment(answer.end).format("YYYY-MM-DD HH:mm:ss"),
            //     };
            //   }),
          });
        }
      }
      if (children.length == 1) {
        let child = children[0];
        resources.push({
          id: getItemId(child),
          title: child.title || "",
          children: undefined,
        });
        continue;
      }
      resources.push({
        id: reference.id || "",
        title: reference.name || "",
        children: children,
      });
    }
    return resources;
  }

  function getEvents() {
    const events: EventInput[] = [];
    const referenceResources = getResources();
    for (let referenceResource of referenceResources || []) {
      const children = referenceResource.children || [referenceResource];
      for (let fieldResource of children || []) {
        for (let answer of answers || []) {
          if (!answer) continue;
          if (!answer.start) continue;
          if (!answer.end) continue;
          if (answer.start < start || answer.start > end) continue;
          if (answer.end < start || answer.end > end) continue;
          if (getItemId(answer.field) != fieldResource.id) continue;
          events.push({
            id: answer.id || "",
            title: answer.value || "Sans nom",
            resourceId: fieldResource.id,
            start: moment(answer.start).format("YYYY-MM-DD HH:mm:ss"),
            end: moment(answer.end).format("YYYY-MM-DD HH:mm:ss"),
          });
        }
      }
    }

    console.log("events", events);
    return events;
  }

  async function onDateClick(
    reference: Reference,
    field: Field,
    start: string,
    end: string
  ) {
    if (isNurse(USER?.get())) return;
    await openAnswersTimelineForm({
      patient,
      reference,
      field,
      start,
      end,
      fieldAnswer: null,
      initialStatus,
      onSave: (answer) => {
        onChange();
      },
    });
  }

  function findReferenceFromField(fieldId: string) {
    for (let reference of references || []) {
      for (let section of reference.sections || []) {
        for (let field of section?.fields || []) {
          if (getItemId(field) != fieldId) continue;
          return reference;
        }
      }
    }
    return null;
  }

  return (
    <div className="calendar">
      <FullCalendar
        key={`FullCalendarRefAnswers${start}`}
        locale={"fr"}
        height={"auto"}
        resourceOrder=""
        initialDate={start || moment().format("YYYY-MM-DD HH:mm:ss")}
        headerToolbar={{
          left: "",
          center: "",
          right: "",
        }}
        // buttonText={{
        //   today: "Aujourd'hui",
        //   month: "Mois",
        //   week: "Semaine",
        //   day: "Jour",
        //   list: "Liste",
        // }}
        eventMinHeight={50}
        contentHeight={50}
        eventShortHeight={50}
        viewHeight={"auto"}
        initialView="resourceTimelineDay"
        resourceAreaWidth={isMobile() ? "150px" : "170px"}
        slotMinWidth={25}
        dayMinWidth={5}
        dateIncrement={{ hours: 2 }}
        plugins={[
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
          resourceTimelinePlugin,
        ]}
        events={getEvents()}
        resources={getResources()}
        resourceLabelContent={(arg) => {
          let title = arg.resource.title;

          return (
            <AnswersTimelineResource
              id={arg.resource.id}
              title={title}
              onEditClick={async () => {
                // await openEditDialog(medicineId);
              }}
            ></AnswersTimelineResource>
          );
        }}
        resourceAreaHeaderContent={(date) => {
          return <div></div>;
        }}
        dayCellContent={(date) => {
          return <div>Day Cell</div>;
        }}
        weekNumberContent={(date) => {
          return <div>Week Number</div>;
        }}
        slotLabelContent={(arg) => {
          return `${moment(arg.date).format("HH")}h `;
        }}
        eventColor="transparent"
        dayCellClassNames={(arg) => {
          return "myCell ";
        }}
        slotLaneClassNames={(arg) => {
          let date = moment(arg.date);
          if (date.hour() < 8 || date.hour() > 16) return "nightshift-lane";
          return "";
        }}
        titleFormat={{ year: "numeric", month: "long", day: "numeric" }}
        displayEventEnd={true}
        dayMaxEvents={true}
        nowIndicator={false}
        scrollTimeReset={false}
        slotEventOverlap={false}
        editable={true}
        selectable={true}
        selectMirror={true}
        eventResourceEditable={true}
        eventChange={async (arg) => {
          let a = arg.event.getResources();
          let answer = answers?.find((answer) => answer.id == arg.event.id);
          if (!answer) return;
          answer.start = moment(arg.event.start).format("YYYY-MM-DD HH:mm");
          answer.end = moment(arg.event.end).format("YYYY-MM-DD HH:mm");
          await apiFetch(
            "fieldAnswers",
            "addOne",
            { fieldAnswer: answer },
            "Erreur lors de la mise à jour de l'élément"
          );
        }}
        eventContent={(arg) => {
          let answer = answers?.find((answer) => answer.id == arg.event.id);
          if (!answer) return <div className="p10"></div>;

          return (
            <AnswersTimelineEvent
              fieldAnswer={answer}
              onClick={async () => {
                if (!answer) return;
                if (isNurse(USER?.get())) {
                  if (answer.status == "finished") answer.status = "pending";
                  else {
                    answer.status = "finished";
                    answer.finishedDate = moment().format(
                      "YYYY-MM-DD HH:mm:ss"
                    );
                  }
                  await apiFetch(
                    "fieldAnswers",
                    "addOne",
                    { fieldAnswer: answer },
                    "Erreur lors de la mise à jour de la tâche"
                  );
                  onChange();
                  return;
                }
                let fieldId = arg.event.getResources()[0]?.id;
                if (!fieldId) throw new Error("No field id");
                const reference = findReferenceFromField(fieldId);
                if (!reference) throw new Error("No reference");

                await openAnswerTimelineActions({
                  answer,
                  patient,
                  reference,
                  onChange: () => {
                    onChange();
                  },
                });
              }}
            />
          );
        }}
        select={async (arg) => {
          let fieldId = arg.resource?.id;
          if (!fieldId) throw new Error("No field id");
          const reference = findReferenceFromField(fieldId);
          if (!reference) throw new Error("No reference");
          let start = moment(arg.start).format("YYYY-MM-DD HH:00");
          let end = moment(arg.end).format("YYYY-MM-DD HH:00");
          let selectedField: Field | null | undefined = null;
          for (let section of reference.sections || []) {
            for (let field of section?.fields || []) {
              if (getItemId(field) != fieldId) continue;
              selectedField = field;
              break;
            }
          }
          if (!selectedField) throw new Error("No selected field");
          await onDateClick(reference, selectedField, start, end);
        }}
      />
    </div>
  );
}
